/**
 * Available densities.
 */

/**
 * Density enum.
 */
var GridDensityTypes;
(function (GridDensityTypes) {
  GridDensityTypes["Compact"] = "compact";
  GridDensityTypes["Standard"] = "standard";
  GridDensityTypes["Comfortable"] = "comfortable";
})(GridDensityTypes || (GridDensityTypes = {}));
export { GridDensityTypes };